import {  TBody } from '../../../types/TxCosmosApi';
import TxMessage from './TxMessage';

type props = {
    body: TBody
}
  
const TxMessages = ({body}: props) => {  
    //! the order of the messages is constant, the messages has no unique ID, and the structure of each message is not constant - I can use index as key! 
    return (
        <div>
            <h4>Messages:</h4>
            {body.messages.map((m, i) => <TxMessage message={m} key={i}/>)}
        </div>
    );
}
  
export default TxMessages;